import React, { useEffect } from "react";
import "./DataDeletion.css";
import BackNavigationBar from "../../components/BackNavigationBar/BackNavigationBar";
import { SUPPORT_EMAIL } from "../../utils/contact";
import { LAST_UPDATED_DATE } from "../../utils/dates";
import { useTranslation } from "react-i18next";

const DataDeletionPage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-full w-full overflow-auto text-white">
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#3BA2F4] opacity-5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-[#3BA2F4] opacity-5 rounded-full blur-3xl"></div>
      </div>
      <BackNavigationBar />
      <main className="relative z-10 px-6 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="mb-8">
            <h1 className="font-heading text-4xl sm:text-5xl font-bold mb-4">
              <span className="gradient-text">{t("global:dataDeletion")}</span>
            </h1>
            {/* <h2 className="font-heading text-xl font-semibold mb-3">
              Data deletion are available in English only.
            </h2> */}
            <p className="text-[#9CA3AF] text-lg">
              {`Last updated: ${LAST_UPDATED_DATE}`}
            </p>
          </div>

          <div className="legal-card legal-content rounded-3xl p-6 sm:p-8 space-y-8">
            <p>
              {t("global:dataDeletionDescription")}
              <br />
              <br />
              {t("global:contactWithQuestions")}{" "}
              <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default DataDeletionPage;
